let isMaintenance = false;
const listeners = new Set<() => void>();

export const maintenanceStore = {
  subscribe: (fn: () => void) => {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
  getSnapshot: () => isMaintenance,
  activate: () => {
    isMaintenance = true;
    listeners.forEach((fn) => fn());
  },
};
